<template>
<div id="services">
    <div class="our-services">
        <div class="wrapper clearfix">
            <div class="col-lg-30 col-md-40 col-sm-60 no-padding">
                <ul>
                    <li><router-link to="#">Автоюрист</router-link></li>
                    <li><router-link to="#">Диагностика</router-link></li>
                    <li><router-link to="#">Дополнительное оборудование</router-link></li>
                    <li><router-link to="#">Замена аккумулятора</router-link></li>
                    <li><router-link to="#">Защитные плёнки</router-link></li>
                    <li><router-link to="#">Кузовные работы</router-link></li>
                    <li><router-link to="#">Масло, жидкости, фильтры</router-link></li>
                    <li><router-link to="#">Мойка, химчистка</router-link></li>
                    <li><router-link to="#">Подвеска</router-link></li>
                    <li><router-link to="#">Покупка резины</router-link></li>
                </ul>
            </div>
            <div class="col-lg-30 col-md-40 col-sm-60 no-padding">
                <ul>
                    <li><router-link to="#">Полировка, уход</router-link></li>
                    <li><router-link to="#">Сложный агрегатный ремонт</router-link></li>
                    <li><router-link to="#">Стёкла, фары</router-link></li>
                    <li><router-link to="#">Техническое обслуживание</router-link></li>
                    <li><router-link to="#">Тонировка</router-link></li>
                    <li><router-link to="#">Тормозная система</router-link></li>
                    <li><router-link to="#">Трансмиссия</router-link></li>
                    <li><router-link to="#">Шиномонтаж</router-link></li>
                    <li><router-link to="#">Электрика</router-link></li>
                    <li><router-link to="#" class="other-services">Другие услуги</router-link></li>
                </ul>
            </div>
            <div class="col-lg-30 col-md-40 col-sm-60 no-padding">
                <ul class="under-menu">
                    <li><router-link to="#">Диагностика АКПП <span>►</span></router-link></li>
                    <li><router-link to="#">Диагностика кондиционера <span>►</span></router-link></li>
                    <li><router-link to="#">Диагностика подвески <span>►</span></router-link></li>
                    <li><router-link to="#">Диагностика тормозной системы <span>►</span></router-link></li>
                    <li><router-link to="#">Заправка кондиционера <span>►</span></router-link></li>
                    <li><router-link to="#">Комплексная диагностика <span>►</span></router-link></li>
                    <li><router-link to="#">Компьютерная диагностика <span>►</span></router-link></li>
                </ul>
            </div>
        </div>
    </div>
    <index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>
    <reviews/>
</div>
</template>

<script>
export default {
  name: 'Services'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Services.vue